const About = () => {
  return (
    <div>
      Made this website to escape a group text.
    </div>
  )
};

export default About;